module.exports = __webpack_public_path__ + "static/media/lead_banner.40156107.jpg";